export const palletsToSendFileInputAcceptTypes = {
   'application/vnd.ms-excel': ['.xls'],
   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
   'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
};
